<script setup lang="ts">
import { ref, onMounted } from 'vue'
import AuthModal from '../../auth/AuthModal.vue'
import { api } from '../../../api/Api'
//import { useNotificationStore } from '../../../stores/notification'
import { tokenManager } from '../../../api/utils/tokenManager'
import { email, required } from '../../../utils/validation'
import TextInput from '../../ui/form/TextInput.vue'
import { useFormValidation } from '../../../composables/useFormValidation'
//const notificationStore = useNotificationStore()

const showLoginModal = ref(false)

const { fields, formData, setFieldRules, validateForm } =
  useFormValidation({
    email: '',
    current_password: '',
    password: '',
    confirm_password: '',
    cid: '',
    uid: '',
  });

const confirmPasswordRule = (message = 'Passwords do not match') => ({
  validate: (value: string) => value === formData.value.password,
  message,
})

setFieldRules('email', [required('Email is required'), email()])
setFieldRules('current_password', [required('Current Password is required')])
setFieldRules('password', [required('Password is required')])
setFieldRules('confirm_password', [
required('Confirmation Password is required'),
    confirmPasswordRule(),
])

const isLoading = ref(false)

const error = ref('')

onMounted(async () => {
    fields.value.email.value = tokenManager.getUser()?.email || '';
    fields.value.cid.value = tokenManager.getCompany()?.uid || '';
    fields.value.uid.value = tokenManager.getUser()?.uid || '';
})

const handleSubmit = async () => {
  if (validateForm()) {
    const response = await api.post('/update-password', formData.value);
    if (response.success == true) {        
        //window.location.href = '/'
         error.value = 'Password updated successfully.'
    } else {
        error.value = 'could not udpate password'
    }
  }
};

</script>

<template>
  <div class="min-h-screen bg-gray-50 dark:bg-gray-900 px-4">
    <div class="mx-auto">
      <!-- Progress Section -->
      <div class="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 mb-8">
        <h1 class="text-2xl font-bold text-gray-900 dark:text-white text-center mb-8">
          Change Password
        </h1>

        <!-- Error Alert -->
        <div 
            v-if="error"
            class="p-4 flex rounded-md bg-red-50 dark:bg-red-900/50 border border-red-200 dark:border-red-800"
        >
            <p class="text-sm  py-2 px-4 text-center text-red-800 dark:text-red-200">{{ error }}</p>
        </div>

        <div id="" class="grid md:grid-cols-3 gap-6">
            <div></div>
            <div>
                <form @submit.prevent="handleSubmit" class="mt-8 space-y-6" novalidate>
                    <TextInput
                        v-model="fields.email.value"
                        label="Email"
                        :readonly="true"
                        :error="
                            fields.email.touched ? fields.email.error : null
                        "
                        @blur="fields.email.touched = true"
                        />

                    <TextInput
                        v-model="fields.current_password.value"
                        type="password"
                        label="Current Password"
                        :error="
                            fields.current_password.touched ? fields.current_password.error : null
                        "
                        @blur="fields.current_password.touched = true"
                        />


                    <TextInput
                        v-model="fields.password.value"
                        type="password"
                        label="Password"
                        :error="
                            fields.password.touched ? fields.password.error : null
                        "
                        @blur="fields.password.touched = true"
                        />

                    <TextInput
                        v-model="fields.confirm_password.value"
                        type="password"
                        label="Cofirm Password"
                        :error="
                            fields.confirm_password.touched ? fields.confirm_password.error : null
                        "
                        @blur="fields.confirm_password.touched = true"
                        />

                    <div class="flex flex-col space-y-3">
                        <button
                        type="submit"
                        :disabled="isLoading"
                        class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                        <span v-if="isLoading">Sending...</span>
                        <span v-else>Update Password</span>
                        </button>

                    </div>
                </form>
            </div>
            <div></div>
        </div>
      </div>
    </div>

    <!-- Login Modal -->
    <AuthModal
      v-if="showLoginModal"
      @close="showLoginModal = false"
    />
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>